import { track } from '../endpoint'

export const chiliTrackApi = {
  post: (path: string, data: object) => {
    if (process.env.NODE_ENV === 'development') {
      return Promise.resolve()
    }
    return fetch(track(path), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'post',
      body: JSON.stringify(data),
    })
  },
}
